import { Transforms, Node } from 'vendor/slate'
import { ReactEditor } from 'vendor/slate-react'
import { insertTabs } from 'cg/components/documents/editor/slate/plugins/tabs'
import { insertUnorderedList, insertOrderedList, insertCheckList } from 'cg/components/documents/editor/slate/plugins/lists'
import { insertCodeTabs } from 'cg/components/documents/editor/slate/plugins/code'
import { insertQuote } from 'cg/components/documents/editor/slate/plugins/quote'
import { insertImage } from 'cg/components/documents/editor/slate/plugins/image'
import { insertFile } from 'cg/components/documents/editor/slate/plugins/file'
import { insertEmbed } from 'cg/components/documents/editor/slate/plugins/embed'
import { insertTable } from 'cg/components/documents/editor/slate/plugins/table'
import { insertHint } from 'cg/components/documents/editor/slate/plugins/hint'
import { insertAppLink } from 'cg/components/documents/editor/slate/plugins/applink'
import { insertApi, insertApiRequest, insertApiResponse } from 'cg/components/documents/editor/slate/plugins/api'
import { insertMath } from 'cg/components/documents/editor/slate/plugins/math'
import { insertMermaid } from 'cg/components/documents/editor/slate/plugins/mermaid'
import { insertSwagger } from 'cg/components/documents/editor/slate/plugins/swagger'
import { insertGraphiql } from 'cg/components/documents/editor/slate/plugins/graphiql'

import { ELEMENT_TYPES, EXISTING_ELEMENT_MENU_ITEMS_BY_KEY } from 'cg/components/documents/editor/slate/types'

const elements = {
  ...ELEMENT_TYPES
}
export default (editor, element, type, path, options = null) => {
  if (type === element.type && !element.skip_type_check) return

  let defaultText = ''

  switch (type) {
    case elements.tabs:
      insertTabs(editor, path)
      break
    case elements.code_tabs:
      insertCodeTabs(editor, path)
      break
    case elements.unordered_list:
      insertUnorderedList(editor, path)
      break
    case elements.ordered_list:
      insertOrderedList(editor, path)
      break
    case elements.check_list:
      insertCheckList(editor, path)
      break
    case elements.quote:
      insertQuote(editor, path)
      break
    case elements.hint:
      insertHint(editor, path)
      break
    case elements.image:
      insertImage(editor, path, options)
      break
    case elements.file:
      insertFile(editor, path, options)
      break
    case elements.embed:
    case elements.video:
    case elements.audio:
    case elements.pdf:
    case elements.loom:
    case elements.figma:
    case elements.gist:
    case elements.typeform:
    case elements.google_drive:
      insertEmbed(editor, path, type)
      break
    case elements.math:
      insertMath(editor, path)
      break
    case elements.mermaid:
      insertMermaid(editor, path)
      break
    case elements.swagger:
      insertSwagger(editor, path)
      break
    case elements.graphiql:
      insertGraphiql(editor, path)
      break
    case elements.issuelink:
    case elements.documentlink:
    case elements.commitlink:
    case elements.mrlink:
      insertAppLink(editor, path, type, options)
      break
    case elements.table:
      insertTable(editor, path)
      break
    case elements.api:
      insertApi(editor, path)
      break
    case elements.api_response:
      insertApiResponse(editor, path)
      break
    case elements.api_request:
      insertApiRequest(editor, path)
      break
    default:
      if (
        EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[element.type] &&
        EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[element.type].items.indexOf(type) !== -1
      ) {
        let text = { text: '' }
        try {
          const [[texts]] = Node.texts(element)
          text = texts
        } catch (err) {}
        if (text && text.text && text.text.length) defaultText = text.text
      }

      Transforms.removeNodes(editor, { at: path })
      Transforms.insertNodes(editor, { type, children: [{ text: defaultText, parent: { type } }] }, { at: path, select: true })
      ReactEditor.focus(editor)
      break
  }
}
